
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-21e8354c&scoped=true!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Tabs.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Tabs.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-21e8354c!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Tabs.vue"),
  /* scopeId */
  "data-v-21e8354c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/common/Tabs.vue
// module id = 397
// module chunks = 0